exports.pricingData = [
  {
    title: "Personal",
    price: "1,000",
    time: "/ 1 Month",
    des: "Perfect for using in a personal website or a client project.",
    content: [
      "1 Restaurant",
      "All Features",
      "Free updates",
      "2 days free trial",
      "2 Weeks support",
    ],
    buttonText: "Choose Personal",
  },
  {
    title: "Business",
    price: "5,000",
    time: "/ 6 Month",
    des: "Perfect for using in a Business website or a client project.",
    content: [
      "1 Restaurant",
      "All Features",
      "Free updates",
      "2 days free trial",
      "4 Months support",
    ],
    buttonText: "Choose Business",
  },
  {
    title: "Professional",
    price: "9,000",
    time: "/ Year",
    des: "Perfect for using in a Professional website or a client project.",
    content: [
      "2 Restaurant",
      "All Features",
      "Free updates",
      "5 days free trial",
      "12 Months support",
    ],
    buttonText: "Choose Professional",
  },
];
